import { CHARITABLE_ENTITY_KINDS } from '@/modules/entities/entities.constants';
import { getEntityKindFromEntityType } from '@/modules/entities/utils/getEntityKindFromEntityType';

import { DispositiveProvisionsContext } from '../contexts/dispositiveProvisions.context';

/**
 * Determines if a source is non-taxable for dispositive provisions tax purposes.
 * Non-taxable sources include:
 * - Non-primary-client individuals (client profiles that are not primary clients)
 * - Charitable entities (CLT, CRT, DAF, private foundation)
 */
export function isNonTaxableSource(
  context: DispositiveProvisionsContext
): boolean {
  const { entityType, isClientProfile, primaryClients, id } = context;

  if (isClientProfile) {
    const isPrimaryClient = primaryClients.some((client) => client.id === id);
    if (!isPrimaryClient) {
      return true;
    }
  }

  if (
    entityType &&
    CHARITABLE_ENTITY_KINDS.includes(getEntityKindFromEntityType(entityType))
  ) {
    return true;
  }

  return false;
}
